import { FC } from 'react'

import styled from 'styled-components'
import { Accordion } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconMenu2 } from '@tabler/icons-react'
import { Drawer } from '@mantine/core'

import { colors } from 'src/Helpers/constants.ts'
import { useMenu } from 'src/Components/Sidebar/useMenu.tsx'
import { UserInfo } from 'src/Components/UserInfo'

import { Button } from '../Button/index.tsx'

const StyledAccordion = styled(Accordion)`
  width: 100%;
`

const StyledButton = styled(Button)`
  flex-shrink: 0;
  background-color: transparent;
  padding: 0;
  width: 50px;
  height: 50px;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: transparent;
    border: none;
  }
`

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 10px;
`

const StyledDrawer = styled(Drawer)`
  .mantine-Drawer-inner {
    top: 0;
    left: 0;
  }

  .mantine-Drawer-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: calc(100% - 60px);
  }
`

const StyledUserInfo = styled(UserInfo)`
  width: 100%;
  margin-top: auto;
`

export const MobSidebar: FC<{
  userName?: string
}> = ({ userName }) => {
  const [opened, { close, open }] = useDisclosure(false)

  const { itemsList, defaultValue } = useMenu(opened)

  return (
    <div>
      <StyledDrawer opened={opened} onClose={close} size={'250px'}>
        <StyledAccordion defaultValue={defaultValue}>
          {itemsList}
        </StyledAccordion>

        <StyledUserInfo name={userName || ''} />
      </StyledDrawer>

      <Container>
        <StyledButton onClick={open}>
          <IconMenu2
            stroke={3}
            color={colors.fourthBlue}
            width={32}
            height={32}
          />
        </StyledButton>
      </Container>
    </div>
  )
}
